import { useQuery } from '@tanstack/react-query';
import { QueryKeys } from '../constants';
import { SecretsControllerService } from '../openapi';

export const useSecrets = (isEnabled: boolean) => {
  return useQuery<Array<string>>([QueryKeys.SECRETS], () => SecretsControllerService.getSecrets(), {
    enabled: isEnabled,
  });
};
